<header
	class="mt-16 bg-[url('/images/pro-banner.png')] bg-cover bg-center bg-no-repeat h-[250px] flex flex-col justify-center mb-7">
	<div class="container">
		<div class="flex items-center justify-between gap-5 flex-wrap">
			<h5 class="uppercase !font-medium text-white opacity-80">{{ title }}</h5>
			<div class="flex items-center gap-x-2">
				@for (link of links; track $index) {
				<a [routerLink]="link.href" class="text-sm text-white" [class.opacity-50]="!link.href">
					{{ link.label }}
				</a>
				@if ($index < links.length - 1) { <lucide-angular [img]="ChevronRight" [color]="'white'" [size]="16">
					</lucide-angular>
					}
					}
			</div>
		</div>
	</div>
</header>